<template>
  <div
    cols="12"
    :class="`border--solid border-radius-8 padding-16 margin-bottom-16 disable-select background-${backgroundColor} border--${borderColor}`"
  >
    <div class="flex-between" @click.stop="setIsVisibleInHeader">
      <slot name="header"></slot>
      <span
        class="color-complementary-200 collapse-rotating icon-hover width--max-content"
        @click.stop="setIsVisible"
      >
        <mdicon name="chevron-down" size="24" />
      </span>
    </div>
    <div><slot name="header-second-row"></slot></div>
    <b-collapse
      v-model="isVisible"
      :accordion="accordion"
      @hidden="handleHidden"
      @show="handleShow"
    >
      <div class="margin-top-16">
        <slot name="body"></slot>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import { ref, toRefs, watch } from "vue";
export default {
  props: {
    accordion: {
      type: String,
      default: "collapse-accordion",
    },
    visible: {
      type: Boolean,
      default: true,
    },
    shouldToggleWithHeader: {
      type: Boolean,
      default: false,
    },
    backgroundColor: {
      type: String,
      default: "surface",
    },
    borderColor: {
      type: String,
      default: "complementary-50",
    },
  },

  setup(props, { emit }) {
    // bind props
    const { visible, shouldToggleWithHeader } = toRefs(props);

    const handleHidden = () => emit("handleHidden");
    const handleShow = () => emit("handleShow");
    const isVisible = ref(visible.value);
    const setIsVisible = () => (isVisible.value = !isVisible.value);
    const setIsVisibleInHeader = () => {
      if (shouldToggleWithHeader.value) {
        setIsVisible();
      }
    };

    watch(visible, (val) => (isVisible.value = val));

    // return data to be used in template
    return {
      handleHidden,
      handleShow,
      isVisible,
      setIsVisible,
      setIsVisibleInHeader,
    };
  },
};
</script>
